var _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeoulIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_171931",
    "data-name": "\\uADF8\\uB8F9 171931",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.036,
    height: 51.749,
    viewBox: "0 0 43.036 51.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_170571",
    "data-name": "\\uADF8\\uB8F9 170571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_120246",
    "data-name": "\\uD328\\uC2A4 120246",
    d: "M586.8,487.6a21.513,21.513,0,0,0-21.519,21.514c0,11.891,21.519,30.235,21.519,30.235s21.517-18.344,21.517-30.235A21.513,21.513,0,0,0,586.8,487.6Z",
    transform: "translate(-565.279 -487.601)",
    fill: "#f8c44f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_120248",
    "data-name": "\\uD328\\uC2A4 120248",
    d: "M587.666,525.783a15.8,15.8,0,1,1,15.792-15.8A15.8,15.8,0,0,1,587.666,525.783Z",
    transform: "translate(-566.145 -488.468)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_170572",
    "data-name": "\\uADF8\\uB8F9 170572",
    transform: "translate(9.096 9.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_120249",
    "data-name": "\\uD328\\uC2A4 120249",
    d: "M588.177,522.913A12.417,12.417,0,1,1,600.589,510.5,12.435,12.435,0,0,1,588.177,522.913Zm0-21.361a8.944,8.944,0,1,0,8.938,8.943A8.956,8.956,0,0,0,588.177,501.552Z",
    transform: "translate(-575.754 -498.079)",
    fill: "#282d33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoulIcon);
export default __webpack_public_path__ + "static/media/seoulIcon.0329cb6c09535ae37f9f71d7171221e4.svg";
export { ForwardRef as ReactComponent };